import { fetchPublicMenus, fetchRestaurantsForMenu } from '@/api/menus';
import { fetchMyProfile } from '@/api/me';
import { useAsyncData } from '@/hooks/useAsyncData';
export function useCheckoutMenus(setCheckoutMenuId) {
    const { data, loading, error } = useAsyncData('checkout-menus', async () => {
        const list = await fetchPublicMenus();
        if (list.length > 0) {
            setCheckoutMenuId((prev) => {
                if (prev != null && list.some((m) => m.id === prev))
                    return prev;
                return list[0].id;
            });
        }
        return list;
    });
    return {
        menus: data ?? [],
        menusLoading: loading,
        menusError: error ? 'Не удалось загрузить меню' : null,
    };
}
export function useCheckoutRestaurants(checkoutMenuId, setPickupRestaurantId) {
    const { data, loading } = useAsyncData(checkoutMenuId != null ? `checkout-restaurants-${checkoutMenuId}` : null, async (signal) => {
        const list = await fetchRestaurantsForMenu(checkoutMenuId);
        if (!signal.aborted) {
            setPickupRestaurantId((prev) => {
                if (prev != null && list.some((r) => r.id === prev))
                    return prev;
                if (list.length === 1)
                    return list[0].id;
                return null;
            });
        }
        return list;
    }, { enabled: checkoutMenuId != null });
    return { restaurants: data ?? [], restaurantsLoading: loading };
}
export function useCheckoutProfile() {
    const { data, loading } = useAsyncData('checkout-profile', async () => {
        try {
            const p = await fetchMyProfile();
            return { profile: p, bonusBalance: p.bonusBalance };
        }
        catch {
            return { profile: null, bonusBalance: null };
        }
    });
    return {
        profile: data?.profile ?? null,
        bonusBalance: data?.bonusBalance ?? null,
        profileLoaded: !loading,
    };
}
